import moment from "moment"
import React, { Component } from "react"
import { Button, Modal } from "react-bootstrap"
import IncidentTimelineTypes from "../../../../../Types/IncidentTimelineTypes"
import "./DeleteIncidentTimelineItem.css"

interface Props {
    incidentTimelineItem: any
    toggleDelete: Function
    deleteIcidentTimelineItem: Function
    contextUserId: number | string
}

class DeleteIncidentTimelineItem extends Component<Props, {}> {

    handleDelete = () => {
        let rb: IncidentTimelineTypes = this.props.incidentTimelineItem
        //@ts-ignore
        rb.DeletedDateUTC = moment().format()
        rb.DeletedBy = parseInt(this.props.contextUserId + "")
        this.props.deleteIcidentTimelineItem(rb)
        this.props.toggleDelete()

    }

    render() {

        return (
            <div className="DeleteIncidentTimelineItem">
                <Modal
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                >
                    <Modal.Header>
                        <div className="DeleteIncidentTimelineModalHeader">
                            <p>Are you sure you want to delete this timeline item?</p>
                        </div>
                    </Modal.Header>
                    <Modal.Footer>
                        <div className="DeleteIncidentTimelineItemModalFooter">
                            <Button variant="secondary" onClick={() => this.props.toggleDelete()}>Back</Button>
                            <Button variant="danger" onClick={() => this.handleDelete()}>Delete</Button>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

export default DeleteIncidentTimelineItem